import merge from "lodash/merge";
export const mergeAlpha = (baseAlpha, alpha) => merge(baseAlpha, alpha);
export const mergeZIndex = (baseZIndex, zIndex) => merge(baseZIndex, zIndex);
export const mergeBreakpoints = (baseBreakpoints, breakpoints) => merge(baseBreakpoints, breakpoints);
export const mergeElevation = (baseElevation, elevation) => merge(baseElevation, elevation);
export const mergePalette = (basePalette, palette) => merge(basePalette, palette);
export const mergeTypography = (baseTypography, typography) => merge(baseTypography, typography);
export const mergeTypographyOptions = (baseTypography, typography) => merge(baseTypography, typography);
export const mergeOverrides = (baseOverrides, overrides) => {
    return merge(baseOverrides, overrides);
};
//# sourceMappingURL=merge.js.map